import { Extension } from '@tiptap/core';
export const Color = Extension.create({
    name: 'color',
    addOptions() {
        return {
            types: ['textStyle']
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    color: {
                        default: null,
                        parseHTML: (element) => element.style.color || null,
                        renderHTML: (attributes) => {
                            if (!attributes.color) {
                                return {};
                            }
                            return {
                                style: `color: ${attributes.color}`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands() {
        return {
            setColor: (color) => ({ chain }) => {
                return chain().setMark('textStyle', { color }).run();
            },
            unsetColor: () => ({ chain }) => {
                return chain().setMark('textStyle', { color: null }).removeEmptyTextStyle().run();
            }
        };
    }
});
